export default "__VITE_ASSET__cbb49f0f__"